import OauthReciever from './oauthReciever.view';

export default OauthReciever;
